import React, { useEffect } from "react";
import Navibar from "../components/Navibar";
import Footer from "../components/Footer";
import baguetteBox from "baguettebox.js";
import "baguettebox.js/dist/baguetteBox.min.css";

import Certifications from "../components/Certifications";

export default function Fabrics() {
  // Reusable FabricCard Component
  const FabricCard = ({ imgSrc, altText, description }) => {
    return (
      <div className="col-sm-6 col-md-4 pb-3">
        <a
          className="lightbox wow zoomIn lister bg-dark"
          href={imgSrc}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
            <img
              src={imgSrc}
              alt={altText}
              style={{
                width: "100%",
                height: "inherit",
                maxHeight: "100%",
                objectFit: "fill",
              }}
            />
          </div>
          <p>{description}</p>
        </a>
      </div>
    );
  };

  // Fabric data
  const fabrics = [
    {
      imgSrc: "/img/Products/Bed/bed1.png",
      altText: "Bridge",
      description: "Piece Dyed Duvet Set",
    },
    {
      imgSrc: "/img/Products/bath/bath10.png",
      altText: "Rails",
      description: "Woven Throw",
    },
    {
      imgSrc: "/img/Products/Bed/bed2.png",
      altText: "Park",
      description: "Printed Duvet Set",
    },
    {
      imgSrc: "/img/Products/Bed/bed3.png",
      altText: "Tunnel",
      description: "Embroidery Pillow Covers",
    },
    {
      imgSrc: "/img/Products/Bed/bed4.png",
      altText: "Traffic",
      description: "Embroidery Stripe Duvet Set",
    },
    {
      imgSrc: "/img/Products/Bed/bed5.png",
      altText: "Coast",
      description: "High Thread count Duvet Set",
    },
    {
      imgSrc: "/img/Products/Bed/bed6.png",
      altText: "Rails",
      description: "Hospital Bed linens",
    },
    {
      imgSrc: "/img/Products/Bed/bed7.png",
      altText: "Rails",
      description: "Striped Bed linen",
    },
    {
      imgSrc: "/img/Products/Bed/bed8.png",
      altText: "Rails",
      description: "Protectors",
    },
    {
      imgSrc: "/img/Products/Bed/bed9.png",
      altText: "Rails",
      description: "Pintucked Bedding set",
    },
  ];

  useEffect(() => {
    baguetteBox.run(".tz-gallery");
  }, []); // Run only once after the component mounts

  return (
    <>
      <Navibar />
      <div className="page-title-area">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container">
              <h2>Bed Linen</h2>
              <p>
                "Elevate your bedroom decor with our exquisite embroidered and
                printed bed linen, blending artistry and comfort."
              </p>
              <div className="d-flex justify-content-around">
                <p className="text-bullet">
                  <li> Embroidered & Printed Bed Linen</li>
                  <li>Duvet & Duvet Cover</li>
                </p>
                <p className="text-bullet">
                  <li>Bed Covers</li>
                  <li>Pillow Shams</li>
                </p>
                <p className="text-bullet">
                  <li>Pillow Covers</li>
                  <li>Cushions</li>
                </p>
                <p className="text-bullet">
                  {" "}
                  <li>Bed Protectors</li>
                </p>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tz-gallery">
        <div className="row">
          {fabrics.map((fabric, index) => (
            <FabricCard
              key={index} // Use index but ideally use a unique id
              imgSrc={fabric.imgSrc}
              altText={fabric.altText}
              description={fabric.description}
            />
          ))}
        </div>
      </div>

      <Certifications />
      <Footer />
    </>
  );
}
